import { useAuthStore } from '@/stores/authStore';

/**
 * Hook kept for backward compatibility. Auth initialization now happens
 * in main.tsx before the app mounts (so beforeLoad guards work on hard nav).
 * This hook is a no-op — the root layout still calls it but it does nothing.
 */
export function useInitAuth() {
  // Auth is initialized in main.tsx before mount. Nothing to do here.
  void useAuthStore.getState();
}
